module.exports = __webpack_public_path__ + "img/skull_5.6cd50796.png";